import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../../../api/axios';

export const mutateWebhook = async (payload) => {
  const { data } = await apiClient.post(`/webhook-configs/test`, payload);
  return data;
};

export const useMutateTestWebhookHandler = ({ onSuccess } = {}) => {
  const mutation = useMutation({
    mutationFn: mutateWebhook,
  });

  return {
    mutateTest: mutation.mutate,
    mutateTestAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
  };
};
